import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 0;
	padding: 20px 20px 20px;
	overflow: hidden;
`;

const StyledHeadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledHeadLeftContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-size: 18px;
		color: #ffffff;
		font-weight: 500;
	}
`;

const StyledHeadRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	width: 240px;

	& > * {
		width: 100%;
	}
`;

const StyledTableWrapper = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledTable = styled.table`
	width: 100%;
	border-collapse: separate;
	border-spacing: 0;
	table-layout: auto;
`;

const StyledTh = styled.th`
	position: sticky;
	top: 0;
	padding: 17px 12px;
	z-index: 1;
	font-size: 14px;
	font-weight: 400;
	color: rgba(255, 255, 255, 0.35);
	text-align: center;
	white-space: nowrap;
	background-color: #111111;
	box-shadow: 0 -4px 0 0 #111111;

	&:first-child {
		padding-left: 20px;
		text-align: left;
	}

	&:last-child {
		padding-right: 20px;
		text-align: right;
	}

	${Text} {
		font-weight: 400;
		font-size: 12px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledTr = styled.tr`
	&:nth-child(odd) {
		background-color: rgba(255, 255, 255, 0.05);
	}

	&:nth-child(even) {
		background-color: rgba(255, 255, 255, 0.02);
	}

	& > td:first-child {
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
	}

	& > td:last-child {
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
	}
`;

const StyledTd = styled.td`
	padding: 16px 12px;
	text-align: center;
	vertical-align: middle;
	white-space: nowrap;

	&:first-child {
		padding-left: 20px;
		text-align: left;
	}

	&:last-child {
		padding-right: 20px;
		text-align: right;
	}

	${Text} {
		font-size: 14px;
		color: #ffffff;
	}
`;

const moneyCellBase = css`
	display: inline-flex;
	align-items: center;
	gap: 8px;
`;

const StyledMoneyCell = styled.div`
	${moneyCellBase}
`;

const StyledProfitCell = styled.div`
	${moneyCellBase}
	color: #4ed957;
	font-weight: 500;
`;

const StyledCircleIcon = styled.div<{ $variant: 'blue' | 'green' }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background-color: ${({ $variant }) =>
		$variant === 'blue' ? '#2f7df5' : '#4ed957'};
	flex-shrink: 0;

	img {
		width: 12px;
		height: 12px;
	}
`;

const StyledMoneyValueContainer = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 6px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}
`;

export {
	StyledCircleIcon,
	StyledContainer,
	StyledHeadContainer,
	StyledHeadLeftContainer,
	StyledHeadRightContainer,
	StyledMoneyCell,
	StyledMoneyValueContainer,
	StyledProfitCell,
	StyledTable,
	StyledTableWrapper,
	StyledTd,
	StyledTh,
	StyledTr,
};
